import { render, staticRenderFns } from "./frase.vue?vue&type=template&id=3d2611b6"
import script from "./frase.vue?vue&type=script&lang=js"
export * from "./frase.vue?vue&type=script&lang=js"
import style0 from "./frase.vue?vue&type=style&index=0&id=3d2611b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports